import { NgModule } from '@angular/core';

// services
import { OpportunitiesFilterService } from './services/opportunities-filter.service';
import { OpportunityViewService } from './services/opportunity-view.service';

// modules
import { InsightsModule } from '@app/insights/insights.module';
import { MarkdownModule } from '@app/markdown/markdown.module';
import { SharedModule } from '@app/shared/shared.module';
import { TagsModule } from '@app/tags/tags.module';
import { OpportunitiesSharedModule } from './opportunities-shared.module';
import { OpportunitiesRoutingModule } from './routes/opportunities-routing.module';

// components
import { OpportunityActivityBadgeService } from '@app/opportunities/components/opportunity-activity-badge/opportunity-activity-badge.service';
import { OpportunitiesModalsModule } from './opportunities-modals.module';

/**
 * NOTE: This module is lazyloaded, do not import it directly into another module.
 *
 * If you need to use components/services that are specific to this module, move
 * them out into the `opportunities-shared.module` and import that that module into
 * your module instead.
 */
@NgModule({
  declarations: [],
  imports: [
    InsightsModule,
    MarkdownModule,
    OpportunitiesModalsModule,
    OpportunitiesRoutingModule,
    OpportunitiesSharedModule,
    SharedModule,
    TagsModule,
  ],
  providers: [OpportunityActivityBadgeService, OpportunitiesFilterService],
})
export class OpportunitiesModule {}
